
























































import Vue, { PropOptions } from 'vue';
import { getBundle } from '../../services/BundleService';
import { Campaign, CampaignAudienceType } from '../../models';
import CampaignService from '../../services/CampaignService';

export default Vue.extend({
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    campaign: Object as PropOptions<Campaign>,
  },
  data() {
    return {
      loading: false,
      smsCredit: 0,
    };
  },
  methods: {
    onFinish(activate: boolean) {
      this.$emit('close', activate);
    },
  },
  watch: {
    async showDialog() {
      this.loading = true;
      try {
        const result = await getBundle();
        const credit = (result.maxCounter || 0) - (result.counter || 0);
        this.smsCredit = credit >= 0 && credit || 0;
      } catch (error) {
        this.onFinish(false);
        this.$store.commit('addSnackbar', {
          text: 'Erro ao resgatar saldo',
        });
      }
      this.loading = false;
    },
  },
  computed: {
    show: {
      get(): boolean {
        return this.showDialog;
      },
      set(showDialog: boolean) {
        if (!showDialog) {
          this.$emit('close');
        }
      },
    },
  },
});
